export const assertUnreachable = (x: never, context?: string): never => {
	throw new Error(
		`Invalid State: The value ${x} is supposed to be unreachable ${
			context ? 'in ' + context : ''
		}`
	);
};

/**
 * Inform the compiler that the value is supposed to be unreachable
 * @param x The value that is supposed to be unreachable
 */
export const informUnreachable = (
	// oxlint-disable-next-line @typescript-eslint/no-unused-vars
	_x: never
) => {
	// exhaustiveness check
};
